import { render, staticRenderFns } from "./texting-dialog.vue?vue&type=template&id=56f81f4c"
import script from "./texting-dialog.vue?vue&type=script&lang=js"
export * from "./texting-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports